import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useMutation } from '@grandvisionhq/graphql';
import { useIntl } from '@grandvisionhq/state';
import { RESCHEDULE_APPOINTMENT_BY_TOKEN } from '../../queries/reschedule-appointment-by-token.js';
import { fromRescheduleAppointmentQueryToAppointment } from './adapters/fromRescheduleAppointmentQueryToAppointment.js';

const useRescheduleAppointmentByToken = ()=>{
    const { locale  } = useIntl();
    const [query, queryState] = useMutation(RESCHEDULE_APPOINTMENT_BY_TOKEN, {
        context: {
            fetchPolicy: 'no-cache',
            forwardHeaders: {
                'Accept-Language': locale
            },
            timeout: 60000
        },
        onError: (error)=>{
            console.error(`Error occurred while executing RESCHEDULE_APPOINTMENT_BY_TOKEN mutation: `, error);
        }
    });
    const data = React.useMemo(()=>{
        var ref;
        return fromRescheduleAppointmentQueryToAppointment((ref = queryState.data) === null || ref === void 0 ? void 0 : ref.rescheduleAppointmentByToken);
    }, [
        queryState.data
    ]);
    return React.useMemo(()=>[
            query,
            swcHelpers.objectSpread({}, queryState, {
                data
            })
        ]
    , [
        data,
        queryState,
        query
    ]);
};

export { useRescheduleAppointmentByToken as default };
//# sourceMappingURL=use-reschedule-appointment-by-token.js.map
